
import Grid from '@material-ui/core/Grid';
import { StyleRulesCallback, withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
// import FileDownloadIcon from '@material-ui/icons/FileDownload';
import DatePicker from 'material-ui-pickers/DatePicker';
import * as React from 'react';
import { Line, } from 'react-chartjs-2';
import * as moment from 'moment'
import HttpService from '../../../modules/core/services/HttpService';
import SnackbarService from '../../../modules/core/services/SnackbarService';

// Modal
import Usage from '../../shared/models/Usage';
import Loading from '../../shared/components/loading/Loading';

const httpService = HttpService.Instance;
const snackbarService = SnackbarService.Instance;
interface IState {
  fromDate: moment.Moment
  toDate: moment.Moment
  usageCount: any[]
  tableIsLoadign: boolean
  graphIsLoading: boolean
  showGraphHourly: boolean
  showGraphTotal: boolean
}

const styles: StyleRulesCallback = (theme: any) => ({
  inLine: {
    display: 'inline-block'
  },
  graphWrap: {
    padding: '32px 0',
    height: '30vh',
    minHeight: 275,
    position: 'relative',
  },
  wideButton: {
    width: '100%'
  }
})

class ProviderAssetUsage extends React.Component<any, IState> {

  private datasetTemplate = {
    label: 'Failed Requests',
    fill: true,
    data: [] as any[],
    backgroundColor: 'rgba(220,220,220,0.4)',
    borderColor: 'rgba(220,220,220,1)',
    pointBackgroundColor: 'rgba(150,150,150,1)',
    pointBorderColor: 'rgba(150,150,150,1)'
  };

  private hourGraph = { type: 'line', datasets:[{...this.datasetTemplate, data:[...this.datasetTemplate.data]}, {...this.datasetTemplate, label:'Succeeded Requests'}]}
  private hourGraphTotal = { type: 'line', datasets:[{...this.datasetTemplate, label:'Total Requests'}]}

  private hourGraphOptions = {
    responsive: true,
    legend: { display: false },
    maintainAspectRatio: false,
    title: {
      display: true
    },
    scales: {
      xAxes: [{
        type: 'time',
        time: {
          unit: "hour" as 'hour'
        }
      }],
      yAxes: [{
        display: true,
        ticks: {
          min: 0
        }
      }]
    }
  }

  private dayGraph = { type: 'line', datasets:[{...this.datasetTemplate, data:[...this.datasetTemplate.data]}, {...this.datasetTemplate, label:'Succeeded Requests'}]}
  private dayGraphTotal = { type: 'line', datasets:[{...this.datasetTemplate, label:'Total Requests'}]}
  private dayGraphOptions = {
    responsive: true,
    legend: { display: false },
    maintainAspectRatio: false,
    title: {
      display: true,
    },
    scales: {
      xAxes: [{
        type: 'time',
        time: {
          unit: "day" as 'day'
        },
      }],
      yAxes: [{
        display: true,
        ticks: {
          min: 0
        }
      }]
    }
  }

  constructor(props: any) {
    super(props);
    this.state = {
      tableIsLoadign: true,
      graphIsLoading: true,
      fromDate: moment(new Date()).startOf('day').subtract(7, 'days'),
      toDate: moment(new Date()).startOf('day'),
      usageCount: [],
      showGraphHourly: false,
      showGraphTotal: false
    };
  }

  public handleChange = (name: string) => (event: any) => {
    this.setState({ ...this.state, [name]: event.target.checked })
  };

  public getCsv() {
    httpService.getCsv(process.env.REACT_APP_API_URL + 'provider/assets/' + this.props.assetId + '/usage?start=' + this.state.fromDate.format() + '&end=' + moment(this.state.toDate).add(1, 'd').format() + '&environment=live')
      .then((response: any) => {
        if (response.ok) { return response.text() }
        return false
      })
      .then((data: any) => {
        if (data) {
          const a = document.createElement('a');
          a.href = URL.createObjectURL(new Blob([data]))
          a.download = "Usage.csv"
          a.type = "text/csv"
          a.click();
        }
      })
  }

  public groupDataWithZeroPadding(data: any, startDateIncl: moment.Moment, endDateExcl: moment.Moment, intervalInMillis: number, valueSelector: string) {
    const start = startDateIncl.valueOf();
    const end = endDateExcl.valueOf();
    const dataInterval: any[] = [];
    for (let index = start; index < end; index += intervalInMillis) {
      dataInterval.push({
        x: moment(index),
        y: 0
      });
    }
    data.forEach((measurement: any) => {
      const index = Math.floor((moment(measurement.hourBlock).valueOf() - start) / intervalInMillis);
      dataInterval[index].y += measurement[valueSelector];
    });
    return dataInterval;
  }

  public getData() {
    const period = moment.duration(this.state.toDate.diff(this.state.fromDate))
    if (period.asMonths() > 3) { snackbarService.showSnackbar('error', "The period can't be more than 3 months. Please select a shorter period.") }
    if (period.asDays() < 1) { snackbarService.showSnackbar('error', "Please select a period of at least one day.") }
    if (period.asDays() >= 1 && period.asMonths() <= 3) {
      const utcEndDate = moment(this.state.toDate).add(1, 'd').utc().format();
      const utcfromDate = moment(this.state.fromDate).utc().format();
      httpService.get(process.env.REACT_APP_API_URL + 'provider/assets/' + this.props.assetId + '/usage?start=' + utcfromDate + '&end=' + utcEndDate + '&environment=live', { enforceErrorPage: false })
        .then((response: Response) => response.ok ? response.json() : [])
        .then((data: any) => {
          const oneHourInterval = 60 * 60 * 1000;
          const hourGraphDataSuccess = this.groupDataWithZeroPadding(data, this.state.fromDate, moment(this.state.toDate).add(1, 'd'), oneHourInterval, 'succeededRequests');
          const hourGraphDataFailed = this.groupDataWithZeroPadding(data, this.state.fromDate, moment(this.state.toDate).add(1, 'd'), oneHourInterval, 'failedRequests');
          const hourGraphDataTotal = this.groupDataWithZeroPadding(data, this.state.fromDate, moment(this.state.toDate).add(1, 'd'), oneHourInterval, 'requestCount');
          const oneDayInterval = 24 * 60 * 60 * 1000;
          const dayGraphDataSuccess = this.groupDataWithZeroPadding(data, this.state.fromDate, moment(this.state.toDate).add(1, 'd'), oneDayInterval, 'succeededRequests');
          const dayGraphDataFailed = this.groupDataWithZeroPadding(data, this.state.fromDate, moment(this.state.toDate).add(1, 'd'), oneDayInterval, 'failedRequests');
          const dayGraphDataTotal = this.groupDataWithZeroPadding(data, this.state.fromDate, moment(this.state.toDate).add(1, 'd'), oneDayInterval, 'requestCount');

          this.dayGraph.datasets[1].data = dayGraphDataSuccess;
          this.hourGraph.datasets[1].data = hourGraphDataSuccess;
          this.dayGraphTotal.datasets[0].data = dayGraphDataTotal;
          this.hourGraphTotal.datasets[0].data = hourGraphDataTotal;
          this.dayGraph.datasets[0].data = dayGraphDataFailed;
          this.hourGraph.datasets[0].data = hourGraphDataFailed;

          const recordset: any[] = [];
          data.forEach((record: Usage) => {
            recordset.push({ ...record, hourBlock: new Date(record.hourBlock) })
          });

          this.setState({ ...this.state, usageCount: recordset, graphIsLoading: false });
        })
    }
  }

  public componentWillMount() {
    this.getData();
  }

  public handleFromDateChange = (date: moment.Moment) => {
    this.setState({ ...this.state, fromDate: date }, () => {
      this.getData();
    });
  }

  public handleToDateChange = (date: moment.Moment) => {
    this.setState({ ...this.state, toDate: date }, () => {
      this.getData();
    });
  }

  public hexToRgb(hex: string) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : {
        r: 0,
        g: 0,
        b: 0
      };
  }

  public render() {
    const { classes, theme } = this.props;
    const primaryColor = theme.palette.primary.main;
    const secondaryColor = theme.palette.secondary.main;
    const redColor = theme.palette.error.dark;
    const secondaryRgb = this.hexToRgb(secondaryColor);
    const secondaryColorTransparent = 'rgba(' + secondaryRgb.r + ',' + secondaryRgb.g + ',' + secondaryRgb.b + ',0.4)';
    const redRgb = this.hexToRgb(redColor);
    const redColorTransparent = 'rgba(' + redRgb.r + ',' + redRgb.g + ',' + redRgb.b + ',0.4)';
    this.hourGraph.datasets[1].backgroundColor = secondaryColorTransparent;
    this.hourGraph.datasets[1].borderColor = secondaryColor;
    this.hourGraph.datasets[1].pointBackgroundColor = primaryColor;
    this.hourGraph.datasets[1].pointBorderColor = secondaryColor;
    this.dayGraph.datasets[1].backgroundColor = secondaryColorTransparent;
    this.dayGraph.datasets[1].borderColor = secondaryColor;
    this.dayGraph.datasets[1].pointBackgroundColor = primaryColor;
    this.dayGraph.datasets[1].pointBorderColor = secondaryColor;
    this.hourGraph.datasets[0].backgroundColor = redColorTransparent;
    this.hourGraph.datasets[0].borderColor = redColor;
    this.hourGraph.datasets[0].pointBackgroundColor = redColor;
    this.hourGraph.datasets[0].pointBorderColor = redColor;
    this.dayGraph.datasets[0].backgroundColor = redColorTransparent;
    this.dayGraph.datasets[0].borderColor = redColor;
    this.dayGraph.datasets[0].pointBackgroundColor = redColor;
    this.dayGraph.datasets[0].pointBorderColor = redColor;

    return (
      <div>
        <Grid container={true} justify="space-between" spacing={16}>
          <Grid item={true}>
            <Grid container={true} justify="flex-start" spacing={16}>
              <Grid item={true}>
                <DatePicker
                  label="From"
                  format="YYYY/MM/DD"
                  value={this.state.fromDate}
                  onChange={this.handleFromDateChange}
                />
              </Grid>
              <Grid item={true}>
                <DatePicker
                  label="To"
                  format="YYYY/MM/DD"
                  value={this.state.toDate}
                  onChange={this.handleToDateChange}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item={true}>
            <Typography className={classes.inLine}>Detailed</Typography>
            <Switch
              checked={this.state.showGraphTotal}
              onChange={this.handleChange('showGraphTotal')}
            />
            <Typography className={classes.inLine}>Total</Typography>
          </Grid>
          <Grid item={true}>
            <Typography className={classes.inLine}>Daily</Typography>
            <Switch
              checked={this.state.showGraphHourly}
              onChange={this.handleChange('showGraphHourly')}
            />
            <Typography className={classes.inLine}>Hourly</Typography>
          </Grid>
        </Grid>
        {!this.state.graphIsLoading && !this.state.showGraphHourly && !this.state.showGraphTotal &&
          <div className={classes.graphWrap}>
            <Line
              data={this.dayGraph}
              options={this.dayGraphOptions}
              redraw={true}
            />
          </div>
        }
        {!this.state.graphIsLoading && this.state.showGraphHourly && !this.state.showGraphTotal &&
          <div className={classes.graphWrap}>
            <Line
              data={this.hourGraph}
              options={this.hourGraphOptions}
              redraw={true}
            />
          </div>
        }
        {!this.state.graphIsLoading && !this.state.showGraphHourly && this.state.showGraphTotal &&
          <div className={classes.graphWrap}>
            <Line
              data={this.dayGraphTotal}
              options={this.dayGraphOptions}
              redraw={true}
            />
          </div>
        }
        {!this.state.graphIsLoading && this.state.showGraphHourly && this.state.showGraphTotal &&
          <div className={classes.graphWrap}>
            <Line
              data={this.hourGraphTotal}
              options={this.hourGraphOptions}
              redraw={true}
            />
          </div>
        }
        {this.state.graphIsLoading &&
          <Loading />
        }
        {!this.state.graphIsLoading &&
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell numeric={true}>Successful calls</TableCell>
                <TableCell numeric={true}>Failed calls</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.state.usageCount.map(n => {
                return (
                  <TableRow key={n.hourBlock}>
                    <TableCell>{moment(n.hourBlock).format('YYYY-MM-DD, h:mm a')}</TableCell>
                    <TableCell numeric={true}>{n.succeededRequests}</TableCell>
                    <TableCell numeric={true}>{n.failedRequests}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        }
      </div>
    )
  };
}

export default withStyles(styles, { withTheme: true })(ProviderAssetUsage)


// WEBPACK FOOTER //
// ./src/modules/provider/pages/ProviderAssetUsage.tsx